import SignatoryFieldWatcher from './SignatoryFieldWatcher'

export default SignatoryFieldWatcher
